import {OptionModel} from 'models/configuration/OptionModel'
import {EventModel} from 'models/EventModel'
import {RegistrationModel} from 'models/registration/RegistrationModel'
import {Memoize} from 'util/memoize'

export type ChoiceKey = string

export type ChoiceConfig = {
	key: ChoiceKey
	label: string
	description: string
	has_payment: boolean
	price: number
	include_comments: boolean
	disabled: boolean
	tag: string
}

export class ChoiceModel {
	option: OptionModel
	config: ChoiceConfig

	constructor(option: OptionModel, config: ChoiceConfig) {
		this.option = option
		this.config = config
	}

	@Memoize()
	get event(): EventModel {
		return this.option.event
	}

	@Memoize()
	get key(): ChoiceKey {
		return this.config.key
	}

	@Memoize()
	get shouldIncludeComments(): boolean {
		return !!this.config.include_comments
	}

	@Memoize()
	get disabled(): boolean {
		return this.config.disabled
	}

	@Memoize()
	get label(): string {
		return this.config.label
	}

	@Memoize()
	get description(): string {
		return this.config.description
	}

	@Memoize()
	get hasPrice(): boolean {
		return this.config.has_payment
	}

	@Memoize()
	get tag(): string {
		return this.config.tag
	}

	getPriceFor(registration: RegistrationModel): number {
		if (!this.hasPrice) {
			return 0
		}
		const status = registration.status
		if (
			status.type === 'invitee' &&
			// Options are free when they are free for some of the tracks
			this.option.tracks.some(track =>
				status.free_tracks.includes(track.key)
			) &&
			status.free_options
		) {
			return 0
		}
		return this.config.price
	}
}
